import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory } from "react-router";
import {
  logoutEstudiosTurnos,
  wsPostTurnosEstudiosQr,
  wsPostTomarTurnoEstudiosQr,
} from "../../context/Actions/turnos/estudioTurnos";
import { hideModal, showModal } from "../../context/Actions/modal/modal";
import {
  logoutConsultaMedTurnos,
  wsPostConsultaMedTurnos,
  wsPostTomarTurnoConsultaMed,
} from "../../context/Actions/turnos/consultaMedTurnos";
import {
  logoutLaboTurnos,
  setBuscarTurnoLabo,
  setFlgCambiarTurno,
  wsGetLaboTurnos,
  wsPostTomarTurnoLaboratorio,
  wsPutCambiarTurnoLaboratorio,
} from "../../context/Actions/turnos/laboTurnos";
import {
  editaTurnosDisponibles,
  finalizaTurnosDisponibles,
  resetFiltrosDisponibles,
  setFechaTurno,
} from "../../context/Actions/turnos/turnosDisponibles";
import { showToaster } from "../../../global/context/action/toaster/toaster";
import Modal from "../../components/Genericos/Modal/Modal";
import Toaster from "../../../global/component/Genericos/Toaster/Toaster";
import HeaderBarFiltros from "../../components/Turnos/HeaderBarFiltros/HeaderBarFiltros";
import CardTurnoFiltro from "../../components/Turnos/CardTurnoFiltro/CardTurnoFiltro";
import EtiquetaGrupoModal from "../../components/Turnos/EtiquetaGrupoModal/EtiquetaGrupoModal";
// import { hideAyuda } from "../../context/Actions/ayuda/ayuda";
import { logicaTomarTurno } from "./TomarTurnoLogica";
import { SetUserProximoTurno } from "../../context/Actions/DropDownFamiliares/selectFamiliares";
import BotonSubir from "../../assets/images/generico/BotonSubir";
import {
  guardarTipoTurno,
  guardarUltimoTurno,
  limpiarDatosMedico,
  limpiarTipoTurno,
  limpiarUltimoTurno,
  resetIdTurnoSolicitud,
} from "../../context/Actions/turnos/turnosPaciente";
import TurnoNoEncontrado from "../../components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import "./TurnosDisponibles.css";
// import { logoutMultiTab } from "../../context/Actions/multiTab/logoutMultiTab";
import { loginTokenReset } from "../../context/Actions/token/loginToken";
import { GlobalContext } from "../../../global/context/Provider";
import { PortalContext } from "../../context/Provider";
import { getHoraString } from "../../../global/utils/getHoraString";
import { getDiaString } from "../../../global/utils/getDiaString";
import camelize from "../../../global/utils/camelize";
// import { displayAyuda, displayAyudaMobile } from "../../../global/utils/ayuda";
import ViewIcon from "../../assets/images/generico/ViewIcon";
import ConsultaIcon from "../../assets/images/generico/ConsultaIcon";
import { setUsuarioAuth } from "../../../global/context/action/auth/login";
import fechaTurnoFormat2 from "global/utils/fechaTurnoFormat2";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { resetLabOrdenDigital } from "_+_Portal/context/Actions/labOrdenDigital/labOrdenDigital";
import {
  BodyTurnosDisponibles,
  TurnosDisponiblesBox,
} from "./styles/localStyle";
import { resetOrdenDigitalEstudio } from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";
// import CardTurnoFiltro2 from "_+_Portal/components/Turnos/CardTurnoFiltro/CardTurnoFiltro2";

const TurnosDisponibles = () => {
  const {
    modalState,
    modalDispatch,
    estudioTurnosDispatch,
    estudioTurnosState,
    consultaMedTurnosState,
    consultaMedTurnosDispatch,
    turnosDisponiblesState,
    turnosDisponiblesDispatch,
    laboTurnosState,
    laboTurnosDispatch,
    // ayudaDispatch,
    selectDropDownState,
    selectDropDownDispatch,
    turnosPacienteDispatch,
    multiTabDispatch,
    tokenState,
    tokenDispatch,
    textosState,
    labOrdenDigitalState,
    labOrdenDigitalDispatch,
    ordenDigitalState,
    ordenDigitalDispatch,
  } = useContext(PortalContext);

  const { authState, authDispatch, toasterDispatch, toasterState } =
    useContext(GlobalContext);

  const [descEspecialidad, setDescEspecialidad] = useState(false);
  const [grupoMedicoOk, setGrupoMedicoOk] = useState(false);
  const [agrupaEtiqueta, setAgrupaEtiqueta] = useState(false);
  const [dtoNuevaBusqueda, setDtoNuevaBusqueda] = useState();
  const [flgNuevaBusqueda, setFlgNuevaBusqueda] = useState(false);
  const [flgActualizarTurnos, setFlgActualizarTurnos] = useState(false);
  const [fechaBusqueda, setFechaBusqueda] = useState();
  const [turnosOriginal, setTurnosOriginal] = useState();
  const [flgRefreshFilter, setRefreshFilter] = useState(false);
  const [onChangeDate, setOnChangeDate] = useState("");
  const [confimoTurno, setConfirmoTurno] = useState(false);
  const [etiquetaPart, setEtiquetaPart] = useState(false);
  const [busquedaDatePicker, setBusquedaDatePicker] = useState(false);
  const [flgExcedeBusq, setFlgExcedeBusq] = useState(false);
  const [excedeBusqMsj, setExcedeBusqMsj] = useState(false);
  const [flgModalExcedeBusq, setFlgModalExcedeBusq] = useState(false);
  const [load, setLoad] = useState(true);
  const [widthWindow, setWidthWindow] = useState(window.innerWidth);
  const [flgBusquedaTurnosLoading, setFlgBusquedaTurnosLoading] =
    useState(false);
  const [turnosDisponibles, setTurnosDisponibles] = useState([]);
  const [visibleCards, setVisibleCards] = useState([]);
  const cardsPerPage = 15;
  let scrollPage = 1;
  const arrxTurnosScroll = useRef([]);
  const visibleLength = useRef(0);

  const history = useHistory();
  const fecha = new Date();
  let accion = sessionStorage.getItem("accionHash");
  let config = localStorage.getItem("config");
  let opcBuscadorTurnos = JSON.parse(config).opcBuscadorTurnos;
  useEffect(() => {
    const handleResize = () => {
      setWidthWindow(window.innerWidth);
    };

    // Agrega el listener de resize cuando el componente se monta
    window.addEventListener("resize", handleResize);

    // Limpia el listener cuando el componente se desmonta
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fechaBuscandoHasta = new Date(
    turnosDisponiblesState.turnosDisponibles.turnosData.fechaBusqueda
  );

  const handleClickVolver = () => {
    if (ordenDigitalState.ordenDigital.flgVolver) {
      resetOrdenDigitalEstudio()(ordenDigitalDispatch);
      history.push("/autocheckin");
    } else {
      history.goBack();
    }
    logoutEstudiosTurnos()(estudioTurnosDispatch);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
    logoutLaboTurnos()(laboTurnosDispatch);
    limpiarUltimoTurno()(turnosPacienteDispatch);
    limpiarTipoTurno()(turnosPacienteDispatch);
    // logoutMultiTab()(multiTabDispatch);
    loginTokenReset()(tokenDispatch);
    resetLabOrdenDigital()(labOrdenDigitalDispatch);
    setUsuarioAuth({
      ...authState.auth.data,
      idProtocolo: null,
      accionToken: null,
    })(authDispatch);
    finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
  };

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const onClickShowDeterminaciones = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "Tus turnos agregados",
        texto: <EtiquetaGrupoModal />,
        dissmiss: dissmiss,
      },
      [
        {
          text: "Continuar",
          clase: "btn-Mensaje-1 bgc-black10 cursor:pointer rb18m c-white",
          accion: dissmiss,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const handleChangeDatePicker = (e) => {
    if (e !== null) {
      setOnChangeDate(e);
      setFechaTurno(e)(turnosDisponiblesDispatch);
      setBusquedaDatePicker(true);
    }
  };

  useEffect(() => {
    resetIdTurnoSolicitud()(turnosPacienteDispatch);
    limpiarDatosMedico()(turnosPacienteDispatch);
    //eslint-disable-next-line
  }, []);

  //cambio la fecha y escucho el cambio para enviarle la fecha correcta
  useEffect(() => {
    if (onChangeDate !== "") {
      onClickProximosTurnos();
      setOnChangeDate("");
    }
    //eslint-disable-next-line
  }, [onChangeDate]);

  // Controla los checks de centros
  const handleChangeCentros = (centroArrx) => {
    let origenLabo =
      turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
      "LABORATORIO";
    if (origenLabo) {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        filtrosData: {
          ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
          centrosLabo: centroArrx,
        },
      })(turnosDisponiblesDispatch);
    } else {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        filtrosData: {
          ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
          centros: centroArrx,
        },
      })(turnosDisponiblesDispatch);
    }
  };

  //este useEffect filtra cuando se desmarco algun item del filtro.
  useEffect(() => {
    if (turnosOriginal !== undefined) {
      filtrarTurnos();
    }
    //eslint-disable-next-line
  }, [turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData]);

  //este useEffect vuelve a hacer el filtrado cuando traigo nuevos turnos.
  useEffect(() => {
    if (flgRefreshFilter) {
      setRefreshFilter(false);
      filtrarTurnos();
    }
    //eslint-disable-next-line
  }, [flgRefreshFilter]);

  // useEffect(() => {
  //   if (turnosOriginal !== undefined && turnosOriginal.length > 0) {
  //     if (
  //       turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
  //       "LABORATORIO"
  //     ) {
  //       filtrarTurnos();
  //     }
  //   }
  //   //eslint-disable-next-line
  // }, [turnosOriginal]);

  const filtrarTurnos = () => {
    // defino una lista aux para filtrar siempre por el mismo resultado.
    if (turnosOriginal !== undefined) {
      // ------------------ ZONA EN LA QUE SE FITRAN LOS CENTROS ------------------------
      let auxCentro = null;
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
        "LABORATORIO"
      ) {
        let centrosLabo =
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
            .centrosLabo;

        auxCentro =
          centrosLabo[0].checked === true
            ? centrosLabo
            : centrosLabo.filter(
                (centro) => centro.checked !== false && centro.id !== 0
              );
      } else {
        let centros =
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
            .centros;

        auxCentro =
          centros[0].checked === true
            ? centros
            : centros.filter(
                (centro) => centro.checked !== false && centro.id !== 0
              );
      }

      // ------------------ ZONA EN LA QUE SE FITRAN LOS ESPECIALISTAS ------------------------
      let especialistas =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .especialistas;
      let auxEsp =
        especialistas[0].checked === true
          ? especialistas
          : especialistas.filter(
              (especialista) =>
                especialista.checked !== false && especialista.id !== 0
            );

      // ------------------ LA ZONA EN LA QUE SE FITRAN LOS DIAS ------------------------
      let dias =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.diasKin;
      let auxDiaSem =
        dias[0].checked === true
          ? dias
          : dias.filter((dia) => dia.checked !== false && dia.id !== 0);

      // ------------------ LA ZONA EN LA QUE SE FITRAN LOS RANGOS ------------------------
      let rangos =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .rangoHorario;

      let auxRango =
        rangos[0].checked === true
          ? rangos
          : rangos.filter((rango) => rango.checked !== false && rango.id !== 0);

      // ------------------ LA ZONA EN LA QUE SE FITRAN QUE SE DEJAN LAS DESC EN EL ARRAY ------------------------
      auxCentro = auxCentro.map((array) => array.descripcion);
      auxEsp = auxEsp.map((array) => array.descripcion);
      auxDiaSem = auxDiaSem.map((array) => array.descripcion);

      let turnoFiltrado = null;
      let turnoFiltradoAux1 = turnosOriginal.filter(
        (item) =>
          // auxCentro.includes(item.centro) &&
          auxCentro.includes(item.centro) &&
          auxEsp.includes(
            item.medico !== null
              ? camelize(item.medico)
              : camelize(item.recepcion)
          ) &&
          auxDiaSem.includes(getDiaString(item.fecha))
      );

      if (auxRango.length > 0) {
        for (let i = 0; i < auxRango.length; i++) {
          let turnoFiltradoAux2 = turnoFiltradoAux1.filter(
            (item) =>
              getHoraString(item.hora) >= auxRango[i].horaMin &&
              getHoraString(item.hora) < auxRango[i].horaMax
          );
          if (i === 0) {
            turnoFiltrado = turnoFiltradoAux2;
          } else {
            turnoFiltrado = turnoFiltrado.concat(turnoFiltradoAux2);
          }
        }
      } else {
        turnoFiltrado = [];
      }

      turnoFiltrado = turnoFiltrado.sort((a, b) => {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(a.fecha) - new Date(b.fecha);
      });
      setTurnosDisponibles(turnoFiltrado);
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        turnos: turnoFiltrado,
      })(turnosDisponiblesDispatch);
      setVisibleCards(turnoFiltrado.slice(0, cardsPerPage));
    }
  };

  let turnosScroll =
    document.documentElement.getElementsByClassName("bodyTurnos");

  // Detecta cuando llegamos al final del scroll y carga más cards
  const handleScroll = () => {
    if (
      turnosScroll[0].scrollTop + turnosScroll[0].clientHeight >=
      turnosScroll[0].scrollHeight
    ) {
      loadMoreCards(arrxTurnosScroll);
    }
  };

  const loadMoreCards = (cards) => {
    const nextPage = scrollPage + 1;
    const startIndex = scrollPage * cardsPerPage;
    const endIndex = startIndex + cardsPerPage;

    if (startIndex < cards?.current.length) {
      const newCards = cards?.current.slice(startIndex, endIndex);
      setVisibleCards((prevCards) => [...prevCards, ...newCards]);
      scrollPage = nextPage;
      visibleLength.current = cards?.current.length;
    }
  };

  useEffect(() => {
    turnosScroll[0].addEventListener("scroll", handleScroll);
    return () => {
      if (turnosScroll[0]) {
        window.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    arrxTurnosScroll.current =
      turnosDisponiblesState.turnosDisponibles.turnosData.turnos;
  }, [turnosDisponiblesState.turnosDisponibles.turnosData.turnos]);

  const handleChangeDia = (diaSemArrx) => {
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        diasKin: diaSemArrx,
      },
    })(turnosDisponiblesDispatch);
  };

  const handleChangeRango = (rangoArrx) => {
    // este editar lo deja vacio sin editar.
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        rangoHorario: rangoArrx,
      },
    })(turnosDisponiblesDispatch);
  };

  const handleChangeEspecialista = (espArrx) => {
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        especialistas: espArrx,
      },
    })(turnosDisponiblesDispatch);
  };

  const handleOnClickConfirmar = (turnoSeleccionado) => {
    setFlgBusquedaTurnosLoading(true);
    const turnoDto = {
      idTurno: turnoSeleccionado.idturno,
      medico: turnoSeleccionado.medico,
      centro: turnoSeleccionado.centro,
      ubicacion: turnoSeleccionado.ubicacion,
      hora: turnoSeleccionado.hora,
      fecha: turnoSeleccionado.fecha,
      especialidad: turnoSeleccionado.especialidad,
    };

    if (
      turnosDisponiblesState.turnosDisponibles.turnosData.proceso === "estudios"
    ) {
      // ESTUDIOS
      const dto = logicaTomarTurno(
        turnosDisponiblesState,
        ordenDigitalState,
        turnoDto,
        selectDropDownState,
        authState,
        "ESTUDIOS",
        dtoNuevaBusqueda
      ).dto;
      const idFamiliar = logicaTomarTurno(
        turnosDisponiblesState,
        ordenDigitalState,
        turnoDto,
        selectDropDownState,
        authState,
        "ESTUDIOS",
        dtoNuevaBusqueda
      ).idFamiliar;
      SetUserProximoTurno(idFamiliar)(selectDropDownDispatch);
      wsPostTomarTurnoEstudiosQr(dto)(estudioTurnosDispatch);
      guardarUltimoTurno(dto.idTurno)(turnosPacienteDispatch);
      guardarTipoTurno({
        tipo: "ESTUDIO",
        estudio:
          turnosDisponiblesState.turnosDisponibles.turnosData.descEstudio,
        circuito: turnosDisponiblesState.turnosDisponibles.turnosData.circuito,
      })(turnosPacienteDispatch);
      setConfirmoTurno(true);
      // }
    } else if (
      turnosDisponiblesState.turnosDisponibles.turnosData.proceso ===
      "consMedica"
    ) {
      // CONSULTA MEDICA
      // La lógica de esta parte está dentro de la función
      const dto = logicaTomarTurno(
        turnosDisponiblesState,
        ordenDigitalState,
        turnoDto,
        selectDropDownState,
        authState,
        "CONSULTA_MEDICA"
      ).dto;
      const idFamiliar = logicaTomarTurno(
        turnosDisponiblesState,
        ordenDigitalState,
        turnoDto,
        selectDropDownState,
        authState,
        "CONSULTA_MEDICA"
      ).idFamiliar;
      SetUserProximoTurno(idFamiliar)(selectDropDownDispatch);
      wsPostTomarTurnoConsultaMed(dto, idFamiliar)(consultaMedTurnosDispatch);
      guardarUltimoTurno(dto.idTurno)(turnosPacienteDispatch);
      guardarTipoTurno({ tipo: "CONSULTA", estudio: dto.descripcion })(
        turnosPacienteDispatch
      );
      setConfirmoTurno(true);
      // }
    } else if (
      turnosDisponiblesState.turnosDisponibles.turnosData.proceso === "labo" &&
      tokenState.token.data === null &&
      !labOrdenDigitalState.labOrdenDigital.altaTurno
    ) {
      // LABORATORIO
      const dto = logicaTomarTurno(
        turnosDisponiblesState,
        ordenDigitalState,
        turnoDto,
        selectDropDownState,
        authState,
        "LABORATORIO",
        dtoNuevaBusqueda,
        authState?.auth?.data?.idProtocolo > 0 &&
          authState?.auth?.data?.idProtocolo,
        turnosDisponiblesState?.turnosDisponibles?.turnosData?.dtoBusqueda
          ?.OsAlternativa
      ).dto;
      const idFamiliar = logicaTomarTurno(
        turnosDisponiblesState,
        ordenDigitalState,
        turnoDto,
        selectDropDownState,
        authState,
        "LABORATORIO",
        dtoNuevaBusqueda,
        turnosDisponiblesState?.turnosDisponibles?.turnosData?.dtoBusqueda
          ?.OsAlternativa
      ).idFamiliar;
      SetUserProximoTurno(idFamiliar)(selectDropDownDispatch);
      wsPostTomarTurnoLaboratorio(dto, idFamiliar)(laboTurnosDispatch);
      guardarUltimoTurno(dto.id)(turnosPacienteDispatch);
      guardarTipoTurno({ tipo: "LABO", estudio: "" })(turnosPacienteDispatch);
      setConfirmoTurno(true);
      // }
    } else if (
      turnosDisponiblesState.turnosDisponibles.turnosData.proceso === "labo" &&
      (tokenState.token.data !== null ||
        labOrdenDigitalState.labOrdenDigital.altaTurno)
    ) {
      // LABORATORIO CON LINK
      if (
        tokenState.token.data?.idProtocolo !== "-1" &&
        tokenState.token.data?.idProtocolo !== null &&
        tokenState.token.data?.idProtocolo !== undefined
      ) {
        const dto = logicaTomarTurno(
          turnosDisponiblesState,
          ordenDigitalState,
          turnoDto,
          selectDropDownState,
          authState,
          "LABORATORIO",
          dtoNuevaBusqueda,
          tokenState.token.data?.idProtocolo
        ).dto;
        const idFamiliar = -1;
        wsPostTomarTurnoLaboratorio(dto, idFamiliar)(laboTurnosDispatch);
        guardarUltimoTurno(dto.id)(turnosPacienteDispatch);
        guardarTipoTurno({ tipo: "LABO", estudio: "" })(turnosPacienteDispatch);
        setConfirmoTurno(true);
      } else {
        // LABORATORIO DESDE ORDENES DIGITALES
        if (labOrdenDigitalState.labOrdenDigital.altaTurno) {
          const dto = logicaTomarTurno(
            turnosDisponiblesState,
            ordenDigitalState,
            turnoDto,
            selectDropDownState,
            authState,
            "LABORATORIO",
            dtoNuevaBusqueda,
            labOrdenDigitalState.labOrdenDigital.altaTurno
          ).dto;
          const idFamiliar = logicaTomarTurno(
            turnosDisponiblesState,
            ordenDigitalState,
            turnoDto,
            selectDropDownState,
            authState,
            "LABORATORIO",
            dtoNuevaBusqueda,
            labOrdenDigitalState.labOrdenDigital.altaTurno
          ).idFamiliar;
          if (laboTurnosState.laboTurnos.flgCambiarTurno) {
            wsPutCambiarTurnoLaboratorio(
              turnoDto.idTurno,
              labOrdenDigitalState.labOrdenDigital.altaTurno,
              idFamiliar ? idFamiliar : -1
            )(laboTurnosDispatch);
          } else {
            wsPostTomarTurnoLaboratorio(dto, idFamiliar)(laboTurnosDispatch);
          }
          guardarUltimoTurno(dto.id)(turnosPacienteDispatch);
          setConfirmoTurno(true);
        } else {
          showToaster(
            {
              texto: "Error al tomar el turno",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
        }
      }
      // }
    } else {
      showToaster(
        {
          texto: "Error al tomar el turno",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  useEffect(() => {
    if (confimoTurno) {
      if (
        laboTurnosState.laboTurnos.data === true ||
        estudioTurnosState.estudioTurnos.data === "" ||
        consultaMedTurnosState.consultaMedTurnos.data > 100 ||
        (laboTurnosState.laboTurnos.data !== null &&
          laboTurnosState.laboTurnos.data !== undefined &&
          laboTurnosState.laboTurnos.data.hora > 1)
      ) {
        logoutEstudiosTurnos()(estudioTurnosDispatch);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
        logoutLaboTurnos()(laboTurnosDispatch);
        resetFiltrosDisponibles()(turnosDisponiblesDispatch); // Este reset da problemas
        finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
        // logoutMultiTab()(multiTabDispatch);
        setFlgCambiarTurno(false)(laboTurnosDispatch);
        setBuscarTurnoLabo(false)(laboTurnosDispatch);
        resetOrdenDigitalEstudio()(ordenDigitalDispatch);
        // limpiar idProtocolo que viene del token
        setUsuarioAuth({
          ...authState.auth.data,
          idProtocolo: null,
          accionToken: null,
        })(authDispatch);
        if (accion) {
          sessionStorage.removeItem("accionHash");
        }
        if (
          turnosDisponiblesState.turnosDisponibles.turnosData?.dtoBusqueda
            ?.videoAtencion
        ) {
          history.push("/videoConsulta");
        } else {
          if (labOrdenDigitalState.labOrdenDigital.altaTurno) {
            resetLabOrdenDigital()(labOrdenDigitalDispatch);
            sessionStorage.setItem("accionLabo", true);
            history.push("/autocheckin");
          } else {
            history.push("/proximosTurnos");
          }
        }
        setConfirmoTurno(false);
      } else if (
        (estudioTurnosState.estudioTurnos.error !== false &&
          estudioTurnosState.estudioTurnos.data !== null) ||
        (consultaMedTurnosState.consultaMedTurnos.error !== false &&
          consultaMedTurnosState.consultaMedTurnos.error !== null) ||
        (laboTurnosState.laboTurnos.error !== false &&
          laboTurnosState.laboTurnos.error !== null)
      ) {
        if (estudioTurnosState.estudioTurnos.error !== null) {
          if (
            estudioTurnosState.estudioTurnos.error.detail !== "" &&
            estudioTurnosState.estudioTurnos.error.detail !== null &&
            estudioTurnosState.estudioTurnos.error.detail !== undefined
          ) {
            if (estudioTurnosState.estudioTurnos.error.detail.length > 100) {
              showModal(
                "Genericos/Mensaje/Mensaje",
                {
                  titulo: "Atención",
                  texto: estudioTurnosState.estudioTurnos.error.detail,
                  dissmiss: dissmiss,
                  danger: true,
                },
                [
                  {
                    text: "Volver",
                    clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                    accion: dissmiss,
                  },
                ],
                "centro"
              )(modalDispatch);
              logoutEstudiosTurnos()(estudioTurnosDispatch);
            } else {
              showToaster(
                {
                  texto: estudioTurnosState.estudioTurnos.error.detail,
                  tipo: "danger",
                },
                "centroArriba"
              )(toasterDispatch);
              logoutEstudiosTurnos()(estudioTurnosDispatch);
            }
          } else {
            showToaster(
              {
                texto: "Error al tomar el turno",
                tipo: "danger",
              },
              "centroArriba"
            )(toasterDispatch);
          }
        } else if (consultaMedTurnosState.consultaMedTurnos.error !== null) {
          if (
            consultaMedTurnosState.consultaMedTurnos.error.detail.length > 100
          ) {
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Atención",
                texto: consultaMedTurnosState.consultaMedTurnos.error.detail,
                dissmiss: dissmiss,
                danger: true,
              },
              [
                {
                  text: "Volver",
                  clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                  accion: dissmiss,
                },
              ],
              "centro"
            )(modalDispatch);
            logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
          } else {
            showToaster(
              {
                texto: consultaMedTurnosState.consultaMedTurnos.error.detail,
                tipo: "danger",
              },
              "centroArriba"
            )(toasterDispatch);
            logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
          }
          setFlgBusquedaTurnosLoading(false);
        } else {
          showToaster(
            {
              texto: "Error al tomar el turno",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          setFlgBusquedaTurnosLoading(false);
        }
      }
    }
    //eslint-disable-next-line
  }, [estudioTurnosState, consultaMedTurnosState, laboTurnosState]);

  const onClickFiltrosMobile = () => {
    showModal(
      "Turnos/FiltrosTurnos/FiltrosTurnos",
      {
        titulo: "Filtrar turnos",
        dissmiss: dissmiss,
        handleClickBuscar: dissmiss,
        handleClickProximos: onClickProximosTurnos,
        handleChangeDatePicker: handleChangeDatePicker,
        flgExcedeBusq: flgExcedeBusq,
        fecha: fecha,
      },
      [],
      "centro"
    )(modalDispatch);
  };

  //HAY QUE MEJORAR Y PREPARAR LA LOGICA PARA TODAS LAS BUSQUEDAS DESDE ACA.

  const onClickProximosTurnos = () => {
    dissmiss();

    let fechaSliced =
      turnosDisponiblesState.turnosDisponibles.turnosData.fechaBusqueda.slice(
        0,
        -9
      );
    if (onChangeDate !== "") {
      fechaSliced = onChangeDate;
    }
    setFlgNuevaBusqueda(true);
    //revisar esto

    setDtoNuevaBusqueda({
      ...dtoNuevaBusqueda,
      fechaDesde: fechaSliced,
    });
    setFechaBusqueda(fechaSliced);
    //lo limpio para que cuando use esta funcion sin el filtro fecha, obtenga le fecha deseada.
    setOnChangeDate("");
  };

  const dissmissReinciarBusq = () => {
    setFlgModalExcedeBusq(false);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
    hideModal()(modalDispatch);
  };

  useEffect(() => {
    if (flgNuevaBusqueda) {
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.proceso ===
        "estudios"
      ) {
        wsPostTurnosEstudiosQr(dtoNuevaBusqueda)(estudioTurnosDispatch);
        setFlgActualizarTurnos(true);
      } else if (
        turnosDisponiblesState.turnosDisponibles.turnosData.proceso ===
        "consMedica"
      ) {
        wsPostConsultaMedTurnos(
          dtoNuevaBusqueda.especialidad,
          dtoNuevaBusqueda.medico,
          fechaBusqueda,
          dtoNuevaBusqueda.flgEspecialidadPart,
          dtoNuevaBusqueda.videoConsulta
        )(consultaMedTurnosDispatch);
        setFlgActualizarTurnos(true);
      } else if (
        turnosDisponiblesState.turnosDisponibles.turnosData.proceso === "labo"
      ) {
        wsGetLaboTurnos(
          fechaBusqueda,
          -1,
          -1,
          dtoNuevaBusqueda.idGrupo
        )(laboTurnosDispatch);
        setFlgActualizarTurnos(true);
      }
    }
    //eslint-disable-next-line
  }, [dtoNuevaBusqueda]);

  useEffect(() => {
    if (flgActualizarTurnos) {
      if (estudioTurnosState?.estudioTurnos?.data?.turnos) {
        let turnosAux1 =
          turnosDisponiblesState.turnosDisponibles.turnosData.turnos;
        let turnosAux2 = estudioTurnosState.estudioTurnos.data.turnos;
        let turnosAux3 = turnosAux1.concat(turnosAux2);

        // En caso de buscar por datepicker ingresa a este if y filtra los turnos mayores al dia seleccionado
        // hasta 7 dias adelante. Tambien borra los turnos que son anteriores a la fecha seleccionada
        if (
          busquedaDatePicker &&
          turnosDisponiblesState.turnosDisponibles.turnosData
            .fechaSeleccionada !== false
        ) {
          const fechaInicial = new Date(
            turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada
          );
          // Sumar 7 días a la fecha inicial
          const fechaNueva = new Date(fechaInicial);
          fechaNueva.setDate(fechaInicial.getDate() + 8);

          let arrx = [];
          for (let i = 0; i < turnosAux3.length; i++) {
            const element = turnosAux3[i];
            if (
              new Date(element.fecha) <= fechaNueva &&
              new Date(element.fecha) >= fechaNueva
            ) {
              arrx.push(element);
            }
          }
          turnosAux3 = arrx;
        }

        let aux4 = turnosAux3.filter(
          (v, i, a) => a.findIndex((v2) => v2.idturno === v.idturno) === i
        );

        //REVISAR AGREGADO
        let auxFecha = "";
        if (estudioTurnosState.estudioTurnos.data.msjFechaLimite === null) {
          auxFecha = estudioTurnosState.estudioTurnos.data.fechaBusqueda;
        }

        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: aux4,
          fechaBusqueda: auxFecha,
          dtoBusqueda: dtoNuevaBusqueda,
        })(turnosDisponiblesDispatch);
        setTurnosDisponibles(aux4);
        setTurnosOriginal(aux4);
        setRefreshFilter(true);

        let arrayE = [];
        var turnoScroll = "";

        if (!estudioTurnosState.estudioTurnos.loading) {
          const lastElement = turnosAux1[turnosAux1.length - 1];
          arrayE.push(lastElement);
          turnoScroll = lastElement;
        }

        if (
          turnosDisponiblesState.turnosDisponibles.turnosData.turnos.length > 0
        ) {
          scrollTest(turnoScroll.idturno);
        }
        if (
          estudioTurnosState.estudioTurnos.data.turnos.length === 0 &&
          estudioTurnosState.estudioTurnos.data.msjFechaLimite !== null &&
          !flgExcedeBusq
        ) {
          let mensaje =
            estudioTurnosState.estudioTurnos.data.msjFechaLimite.descripcion;

          //accion cuando ya no tengo turnos.
          setFlgExcedeBusq(true);
          setExcedeBusqMsj(mensaje);
          if (aux4.length > 0) {
            //mensaje cuando ya tenia turnos.
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Atención",
                texto: mensaje,
                dissmiss: dissmissReinciarBusq,
              },
              [
                {
                  text: "Reiniciar búsqueda",
                  clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
                  accion: reiniciaBusquedaModal,
                },
                {
                  text: "Volver",
                  clase: "btn-Mensaje b-latex30 rb16m c-latex30",
                  accion: dissmissReinciarBusq,
                },
              ],
              "centro"
            )(modalDispatch);
          }
        } else {
          setFlgExcedeBusq(false);
          setExcedeBusqMsj("");
        }
        setBusquedaDatePicker(false);
      }
    }
    //eslint-disable-next-line
  }, [estudioTurnosState]);

  const reiniciaBusquedaModal = () => {
    setFlgModalExcedeBusq(true);
    setFlgExcedeBusq(false);
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      turnos: [],
      fechaBusqueda: fechaTurnoFormat2(),
    })(turnosDisponiblesDispatch);
    setTurnosDisponibles([]);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
  };

  useEffect(() => {
    if (flgModalExcedeBusq) {
      setFlgModalExcedeBusq(false);
      dissmiss();
      onClickProximosTurnos();
    }
  }, [flgModalExcedeBusq]);

  useEffect(() => {
    if (flgActualizarTurnos) {
      if (consultaMedTurnosState.consultaMedTurnos?.data?.data) {
        let turnosAux1 =
          turnosDisponiblesState.turnosDisponibles.turnosData.turnos;
        let turnosAux2 = consultaMedTurnosState.consultaMedTurnos.data.data;
        let turnosAux3 = turnosAux1.concat(turnosAux2);
        let aux4 = turnosAux3.filter(
          (v, i, a) => a.findIndex((v2) => v2.idturno === v.idturno) === i
        );

        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: turnosAux3,
          fechaBusqueda:
            consultaMedTurnosState.consultaMedTurnos.data.fechaBusqueda,
          dtoBusqueda: dtoNuevaBusqueda,
        })(turnosDisponiblesDispatch);
        setTurnosDisponibles(aux4);
        setTurnosOriginal(aux4);
        setRefreshFilter(true);

        let arrayE = [];
        var turnoScroll = "";

        if (!estudioTurnosState.estudioTurnos.loading) {
          const lastElement = turnosAux1[turnosAux1.length - 1];
          arrayE.push(lastElement);
          turnoScroll = lastElement;
        }

        if (
          turnosDisponiblesState.turnosDisponibles.turnosData.turnos.length > 0
        ) {
          scrollTest(turnoScroll.idturno);
        }
        //activoFlg msjBusqFechaLimite
        if (
          consultaMedTurnosState.consultaMedTurnos.data.data.length === 0 &&
          consultaMedTurnosState.consultaMedTurnos.data.msjFechaLimite !== null
        ) {
          setFlgExcedeBusq(true);
          setExcedeBusqMsj(
            consultaMedTurnosState.consultaMedTurnos.data.msjFechaLimite
              .descripcion
          );
          if (turnosAux3.length > 0) {
            //mensaje cuando ya tenia turnos.
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Atención",
                texto:
                  consultaMedTurnosState.consultaMedTurnos.data.msjFechaLimite
                    .descripcion,
                dissmiss: dissmissReinciarBusq,
              },
              [
                {
                  text: "Reiniciar búsqueda",
                  clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
                  accion: reiniciaBusquedaModal,
                },
                {
                  text: "Volver",
                  clase: "btn-Mensaje b-latex30 rb16m c-latex30",
                  accion: dissmissReinciarBusq,
                },
              ],
              "centro"
            )(modalDispatch);
          }
        } else {
          setFlgExcedeBusq(false);
          setExcedeBusqMsj("");
        }
      }
    }
    //eslint-disable-next-line
  }, [consultaMedTurnosState]);

  useEffect(() => {
    if (flgActualizarTurnos) {
      if (laboTurnosState.laboTurnos?.data?.data) {
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: laboTurnosState.laboTurnos.data.data,
          fechaBusqueda: laboTurnosState.laboTurnos.data.fechaBusqueda,
          dtoBusqueda: dtoNuevaBusqueda,
        })(turnosDisponiblesDispatch);
        setTurnosDisponibles(laboTurnosState.laboTurnos.data.data);
        setTurnosOriginal(laboTurnosState.laboTurnos.data.data);
        setRefreshFilter(true);
        if (
          laboTurnosState.laboTurnos.data.data.length === 0 &&
          laboTurnosState.laboTurnos.data.msjFechaLimite !== null
        ) {
          setFlgExcedeBusq(true);
          setExcedeBusqMsj(
            laboTurnosState.laboTurnos.data.msjFechaLimite.descripcion
          );
          if (laboTurnosState.laboTurnos.data.data.length > 0) {
            //mensaje cuando ya tenia turnos.
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Atención",
                texto:
                  laboTurnosState.laboTurnos.data.msjFechaLimite.descripcion,
                dissmiss: dissmissReinciarBusq,
              },
              [
                {
                  text: "Reiniciar búsqueda",
                  clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
                  accion: reiniciaBusquedaModal,
                },
                {
                  text: "Volver",
                  clase: "btn-Mensaje b-latex30 rb16m c-latex30",
                  accion: dissmissReinciarBusq,
                },
              ],
              "centro"
            )(modalDispatch);
          }
        } else {
          setFlgExcedeBusq(false);
          setExcedeBusqMsj("");
        }
      }
    }
    //eslint-disable-next-line
  }, [laboTurnosState]);

  useEffect(() => {
    if (turnosDisponiblesState.turnosDisponibles.turnosData.turnos === null) {
      if (opcBuscadorTurnos && widthWindow > 1024) {
        history.push("/buscadorTurnos");
      } else {
        history.push("/consultamedica");
      }
      // este fix de consultamedica y los signos de pregunta"?" que se ven en las asignaciones luego
      // del return son para que no pinche si apretamos f5
    } else {
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.descEspecialidad !==
          "" &&
        turnosDisponiblesState.turnosDisponibles.turnosData.descEspecialidad !==
          null
      ) {
        setDescEspecialidad(true);
      }
      setEtiquetaPart(
        turnosDisponiblesState.turnosDisponibles.turnosData.particular
      );
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.GruposMedico !==
        null
      ) {
        setGrupoMedicoOk(true);
        if (
          turnosDisponiblesState.turnosDisponibles.turnosData.GruposMedico
            .length > 1
        ) {
          setAgrupaEtiqueta(true);
          setEtiquetaPart(false);
        } else {
          if (
            turnosDisponiblesState.turnosDisponibles.turnosData.GruposMedico[0]
              .particular
          ) {
            setEtiquetaPart(true);
          }
        }
      }
      setTurnosOriginal(
        turnosDisponiblesState.turnosDisponibles.turnosData.turnos
      );
      setTurnosDisponibles(
        turnosDisponiblesState.turnosDisponibles.turnosData.turnos
      );
      setVisibleCards(
        turnosDisponiblesState.turnosDisponibles.turnosData.turnos.slice(
          0,
          cardsPerPage
        )
      );
      setDtoNuevaBusqueda(
        turnosDisponiblesState.turnosDisponibles.turnosData.dtoBusqueda
      );
      setLoad(false);
      // hideAyuda()(ayudaDispatch);
      // displayAyuda("hidden");
      // displayAyudaMobile("hidden");
    }

    return () => {
      loginTokenReset()(tokenDispatch);
    };
    //eslint-disable-next-line
  }, []);

  // const [testRef, setTestRef] = useState();

  const myRef = useRef({});

  const scrollTest = (e) => {
    let id = myRef.current[e];
    if (
      id !== null &&
      !estudioTurnosState.estudioTurnos.loading &&
      !consultaMedTurnosState.consultaMedTurnos.loading &&
      !laboTurnosState.laboTurnos.loading
    ) {
      id?.scrollIntoView({ behavior: "smooth", block: "center" });
      id?.focus();
    }
  };

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}
      <Loading
        dataLoading={
          estudioTurnosState.estudioTurnos.loading ||
          consultaMedTurnosState.consultaMedTurnos.loading ||
          laboTurnosState.laboTurnos.loading
        }
        color="c-white"
        descripcion={
          ((estudioTurnosState.estudioTurnos.loading ||
            consultaMedTurnosState.consultaMedTurnos.loading ||
            laboTurnosState.laboTurnos.loading) &&
            flgBusquedaTurnosLoading &&
            "Tomando turno...") ||
          ((estudioTurnosState.estudioTurnos.loading ||
            consultaMedTurnosState.consultaMedTurnos.loading ||
            laboTurnosState.laboTurnos.loading) &&
            !flgBusquedaTurnosLoading &&
            "Buscando turnos...")
        }
      />
      <HeaderBarFiltros
        handleClickVolver={handleClickVolver}
        handleChangeDatePicker={handleChangeDatePicker}
        handleChangeCentros={handleChangeCentros}
        handleChangeDia={handleChangeDia}
        handleChangeRango={handleChangeRango}
        handleChangeEspecialista={handleChangeEspecialista}
        turnosData={turnosDisponiblesState.turnosDisponibles.turnosData.turnos}
        filtrosData={
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
        }
        fecha={fecha}
      />
      <div className="ptur-turnosDisponibles-headerTurno">
        <div className="ptur-turnosDisponibles-etiqueta">
          <ConsultaIcon color={"var(--color-white)"} />
          {etiquetaPart ? (
            <span className="ptur-turnosAgregados-descParticular c-white rb14b">
              PARTICULAR:
            </span>
          ) : (
            ""
          )}
          <span className="ptur-turnosDisponibles-etiquetaDesc c-white rb14l">
            {grupoMedicoOk ? (
              agrupaEtiqueta ? (
                <button
                  onClick={() => onClickShowDeterminaciones()}
                  className="ptur-turnosAgregados-cancelarBtn c-white"
                >
                  VER ESTUDIOS AGREGADOS
                  <span className="ptur-turnosDisponibles-viewIcon">
                    <ViewIcon />
                  </span>
                </button>
              ) : descEspecialidad ? (
                turnosDisponiblesState.turnosDisponibles.turnosData
                  .descEspecialidad
              ) : (
                turnosDisponiblesState.turnosDisponibles.turnosData.descEstudio
              )
            ) : descEspecialidad ? (
              turnosDisponiblesState.turnosDisponibles.turnosData
                .descEspecialidad
            ) : (
              turnosDisponiblesState.turnosDisponibles.turnosData.descEstudio
            )}
          </span>
        </div>
        <div className="ptur-turnosDisponibles-filtrosMobile-container">
          {turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen !==
            "LABORATORIOQR" && (
            <button
              onClick={onClickFiltrosMobile}
              className="ptur-turnosDisponibles-filtrosMobile-btn c-latex30 rb18mh"
            >
              Filtros
            </button>
          )}

          {!flgExcedeBusq ? (
            <div className="ptur-turnosDisponibles-proxTurnosBar anchoDisable600Min">
              <button
                onClick={onClickProximosTurnos}
                className="btn ptur-turnosDisponibles-proxTurnosBtn"
              >
                Buscar más turnos
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="ptur-turnosDisponibles-proxTurnosBar">
          {!flgExcedeBusq ? (
            <button
              onClick={onClickProximosTurnos}
              className="ptur-turnosDisponibles-proxTurnosBtn anchoDisable1366Max"
            >
              Buscar más turnos
            </button>
          ) : (
            ""
          )}
          <div className="ptur-turnosDisponibles-proxTurnosBar-pacienteFecha">
            {/* <p className="rb16m ptur-turnosDisponibles-proxTurnosBar-title">
              {" "}
              <span style={{ marginRight: "10px" }}>Para:</span>
              {turnosDisponiblesState.turnosDisponibles.turnosData
                .volverOrigen === "CONSULTA_MEDICA"
                ? !selectDropDownState.selectDropDown.selectGlobal
                    .pacienteElegido
                  ? camelize(authState.auth.data.paciente.nombre)
                  : camelize(
                      selectDropDownState.selectDropDown.selectGlobal
                        .pacienteElegido.paciente.nombre
                    )
                : turnosDisponiblesState.turnosDisponibles.turnosData
                    .volverOrigen === "ESTUDIOS"
                ? !selectDropDownState.selectDropDown.selectGlobal
                    .pacienteElegido
                  ? camelize(authState.auth.data.paciente.nombre)
                  : camelize(
                      selectDropDownState.selectDropDown.selectGlobal
                        .pacienteElegido.paciente.nombre
                    )
                : turnosDisponiblesState.turnosDisponibles.turnosData
                    .volverOrigen === "LABORATORIO"
                ? !selectDropDownState.selectDropDown.selectGlobal
                    .pacienteElegido
                  ? camelize(authState.auth.data.paciente.nombre)
                  : camelize(
                      selectDropDownState.selectDropDown.selectGlobal
                        .pacienteElegido.paciente.nombre
                    )
                : camelize(authState.auth.data.paciente.nombre)}
            </p> */}
            {!flgExcedeBusq ? (
              <p className="rb16m ptur-turnosDisponibles-proxTurnosBar-title">
                {" "}
                <span style={{ marginRight: "10px" }}>
                  Fecha de búsqueda hasta:
                </span>
                {turnosDisponiblesState.turnosDisponibles.turnosData
                  .fechaBusqueda === ""
                  ? ""
                  : turnosDisponiblesState.turnosDisponibles.turnosData
                      .volverOrigen === "CONSULTA_MEDICA"
                  ? turnosDisponiblesState.turnosDisponibles.turnosData
                      .volverOrigen === "ESTUDIOS"
                    ? `${fechaBuscandoHasta.getDate()}/${
                        fechaBuscandoHasta.getMonth() + 1
                      }/${fechaBuscandoHasta.getFullYear()}`
                    : `${fechaBuscandoHasta.getDate()}/${
                        fechaBuscandoHasta.getMonth() + 1
                      }/${fechaBuscandoHasta.getFullYear()}`
                  : `${fechaBuscandoHasta.getDate()}/${
                      fechaBuscandoHasta.getMonth() + 1
                    }/${fechaBuscandoHasta.getFullYear()}`}
              </p>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <BodyTurnosDisponibles
        initial={{ opacity: 0, y: +100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
        className="bodyTurnos"
      >
        {!load && (
          <TurnosDisponiblesBox>
            {turnosDisponibles.length === 0 ? (
              <>
                <TurnoNoEncontrado
                  excedeBusqMsj={excedeBusqMsj}
                  excedeBusqueda={flgExcedeBusq}
                  state={turnosDisponibles}
                  loadingState={turnosDisponiblesState.turnosDisponibles}
                  texto={textosState.textos.data?.msjSinTurnoDisponible?.nombre.slice(
                    0,
                    -7
                  )}
                  recomendacion={
                    textosState.textos.data?.msjSinTurnoDisponible?.descripcion
                  }
                  fecha={new Date(
                    turnosDisponiblesState.turnosDisponibles.turnosData.fechaBusqueda
                  ).toLocaleDateString()}
                  txtBtn={
                    !flgExcedeBusq
                      ? "Proximos turnos disponibles"
                      : "Reiniciar Búsqueda"
                  }
                  onClickTurnos={onClickProximosTurnos}
                  showBtn={true}
                />
              </>
            ) : widthWindow < 1024 ? (
              visibleCards.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <div
                      ref={(el) => (myRef.current[item.idturno] = el)}
                      id={item.idturno}
                    >
                      <CardTurnoFiltro
                        handleOnClickConfirmar={() =>
                          handleOnClickConfirmar(item)
                        }
                        idTurno={item.idturno}
                        medico={camelize(
                          item.medico !== null ? item.medico : ""
                        )}
                        centro={item.centro}
                        ubicacion={item.ubicacion}
                        coordenadaGps={item.coordenadaGps}
                        hora={item.hora}
                        fecha={item.fecha}
                        especialidad={
                          item.especialidad !== null
                            ? camelize(item.especialidad)
                            : ""
                        }
                        proceso={
                          turnosDisponiblesState.turnosDisponibles?.turnosData
                            ?.proceso
                        }
                      />
                    </div>
                  </React.Fragment>
                );
              })
            ) : (
              turnosDisponibles.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <div
                      ref={(el) => (myRef.current[item.idturno] = el)}
                      id={item.idturno}
                    >
                      <CardTurnoFiltro
                        handleOnClickConfirmar={() =>
                          handleOnClickConfirmar(item)
                        }
                        idTurno={item.idturno}
                        medico={camelize(
                          item.medico !== null ? item.medico : ""
                        )}
                        centro={item.centro}
                        ubicacion={item.ubicacion}
                        coordenadaGps={item.coordenadaGps}
                        hora={item.hora}
                        fecha={item.fecha}
                        especialidad={
                          item.especialidad !== null
                            ? camelize(item.especialidad)
                            : ""
                        }
                        proceso={
                          turnosDisponiblesState.turnosDisponibles?.turnosData
                            ?.proceso
                        }
                      />
                    </div>
                  </React.Fragment>
                );
              })
            )}
          </TurnosDisponiblesBox>
        )}

        {estudioTurnosState.estudioTurnos.loading ||
        consultaMedTurnosState.consultaMedTurnos.loading ||
        laboTurnosState.laboTurnos.loading ? (
          ""
        ) : (
          <div className="ptur-turnosDisponibles-botonSubir">
            <BotonSubir body={"bodyTurnos"} />
          </div>
        )}

        <div className="footerHelpTurnosDisp"></div>
      </BodyTurnosDisponibles>
    </React.Fragment>
  );
};

export default TurnosDisponibles;
